<div class="p-a-5 p-l-1-s p-r-1-s p-l-1-m p-r-1-m b-b b-col-5 ">
    <button type="button"
            class="flex flex-middle flex-justify-between cursor-pointer w-12"
            (click)="toggle()">

        <!-- title -->
        <div class="flex flex-justify-between flex-middle w-12 s1">
            @switch (!!expandableTitle) {
            @case (true) {
            <label class="cursor-pointer s1">
                {{expandableTitle}}
            </label>
            }
            @default {
            <div class="flex-column left">
                <span class="p-t-1 p-b-1">
                    <ng-container *ngTemplateOutlet="expandableTitleTpl" />
                </span>
                @if(optionsLabels){
                <span class="p2 col-11 m-t-1">{{optionsLabels}}</span>
                }
            </div>
            @if (selectedOptionsQty) {
            <div class="b-radius-max bg-col-62 col-1 m-r-2 center"
                 style="width: 20px; height: 20px;">
                <p class="s2">{{selectedOptionsQty}}</p>
            </div>
            }
            }
            }
        </div>

        <!-- icon -->
        <div lineHeightBy="s1">
            <i [toggleClassBy]="openState"
               [toggleClass]="'icon-chevron-up !icon-chevron-down'"></i>
        </div>
    </button>

    <!-- body -->
    <div [hideUp]="openState">
        @switch (!!expandableTitle) {
        @case (true) {
        <ng-container *ngTemplateOutlet="expandableContentTpl" />
        }
        @default {
        <ng-container *ngTemplateOutlet="expandableBodyTpl" />
        }
        }
    </div>
</div>

<ng-template #expandableTitleTpl>
    <ng-content select="[expandableTitle]"></ng-content>
</ng-template>
<ng-template #expandableBodyTpl>
    <ng-content select="[expandableBody]"></ng-content>
</ng-template>
<ng-template #expandableContentTpl>
    <ng-content></ng-content>
</ng-template>